import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LgvClientService } from '../../core/core.module';
import { AdjustHomeValueDialogComponent } from '../adjust-home-value-dialog/adjust-home-value-dialog.component';

@Component({
  selector: 'lgv-custom-valuation-dialog',
  templateUrl: './custom-valuation-dialog.component.html',
  styleUrls: ['./custom-valuation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomValuationDialogComponent implements OnInit {
  propertyAdjustments: any;
  isCustomValuationText: boolean;
  constructor(public dialogRef: MatDialogRef<CustomValuationDialogComponent>,
    private lgvClientService: LgvClientService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog) {
      this.isCustomValuationText = this.data?.isCustomValuationText;
    }

  ngOnInit(): void {
    this.propertyAdjustments = this.lgvClientService.SelectedProperty$.value?.clientPropertyAdjustments[0];
  }

  onAdjustHomeValue() {
    this.dialogRef.close();
    this.dialog.open(AdjustHomeValueDialogComponent, {
      width: '500px',
      minHeight: '700px'
    });
  }

}
